document.addEventListener('DOMContentLoaded', () => {
    const tabModule = document.querySelectorAll('.js_tabModule');

    class Tab {
        constructor(target) {
            this.target = target;

            this.tabBtnArray = Array.from(
                this.target.querySelectorAll('.js_btn')
            ).filter(el => el.closest('.js_tabModule') === this.target);

            this.tabConArray = Array.from(
                this.target.querySelectorAll('.js_tabContents')
            ).filter(el => el.closest('.js_tabModule') === this.target);
        }

        tabFn() {
            this.tabBtnArray.forEach((btn, index) => {
                btn.addEventListener('click', () => {
                    this.tabBtnArray.forEach(el => {
                        el.classList.remove('on');
                    });

                    btn.classList.add('on');

                    this.tabConArray.forEach(el => {
                        el.classList.remove('on');
                    });

                    if (this.tabConArray[index]) {
                        this.tabConArray[index].classList.add('on');
                    }
                });
            });
        }
    }

    tabModule.forEach(el => {
        new Tab(el).tabFn();
    });
});